import { gql } from '@apollo/client';

export const CLIENT_FIELDS = gql`
  fragment ClientFields on Client {
    id
    name
    tenantId
    marginOverridePercentage
    paymentTerm
    chargeType
    logoUrl
    status
    logoUrl
    description
    classifications {
      id
      name
      description
      classificationGroupId
    }
    address {
      addressLine1
      addressLine2
      addressFriendly
      suburb
      state
      postcode
      countryLabel
      countryValue
    }
    latLng {
      lat
      lng
    }
    customAttributes {
      ref
      value
    }
    rateCard {
      bookingFeeCents
      currency
      effectiveFrom
      tiers {
        type
        minDays
        maxDays
        label
        flatCents
        perDayCents
      }
    }
    effectiveRateCard {
      bookingFeeCents
      currency
      effectiveFrom
      tiers {
        type
        minDays
        maxDays
        label
        flatCents
        perDayCents
      }
    }
  }
`;

// Client Queries
export const GET_CLIENT = gql`
  ${CLIENT_FIELDS}
  query GetClient($id: String!) {
    getClient(id: $id) {
      ...ClientFields
    }
  }
`;

export const GET_ALL_CLIENTS = gql`
  ${CLIENT_FIELDS}
  query GetAllClients {
    getAllClients {
      ...ClientFields
    }
  }
`;

export const GET_ALL_CLIENTS_FOR_TENANT = gql`
  ${CLIENT_FIELDS}
  query GetAllClientsForTenant(
    $tenantId: String!
    $lastEvaluatedKey: String
    $limit: Int
    $forceFetchAll: Boolean
  ) {
    getAllClientsForTenant(
      tenantId: $tenantId
      lastEvaluatedKey: $lastEvaluatedKey
      limit: $limit
      forceFetchAll: $forceFetchAll
    ) {
      items {
        ...ClientFields
      }
      lastEvaluatedKey
      hasMore
    }
  }
`;

// Client Mutations
export const CREATE_CLIENT = gql`
  ${CLIENT_FIELDS}
  mutation CreateClient($details: ClientInput!) {
    createClient(details: $details) {
      ...ClientFields
    }
  }
`;

export const UPDATE_CLIENT = gql`
  ${CLIENT_FIELDS}
  mutation UpdateClient($id: String!, $details: ClientInput!) {
    updateClient(id: $id, details: $details) {
      ...ClientFields
    }
  }
`;

export const SET_CLIENT_STATUS = gql`
  ${CLIENT_FIELDS}
  mutation SetClientStatus($id: String!, $status: ClientStatus!) {
    setClientStatus(id: $id, status: $status) {
      ...ClientFields
    }
  }
`;

export const SET_CLIENT_RATE_CARD = gql`
  ${CLIENT_FIELDS}
  mutation SetClientRateCard(
    $clientId: String!
    $rateCard: ClientRateCardInput!
  ) {
    setClientRateCard(clientId: $clientId, rateCard: $rateCard) {
      ...ClientFields
    }
  }
`;

export const DELETE_CLIENT = gql`
  mutation DeleteClient($id: String!) {
    deleteClient(id: $id)
  }
`;
